/**
 * AuthGlassCard — historical name, kept so existing pages don't churn.
 *
 * The glassmorphism treatment was retired with the Option A split-panel
 * shell: forms now sit directly on the system surface, so this is just a
 * plain width container. The name survives because Login / OAuthCallback /
 * ResetPassword already compose with it.
 */

export default function AuthGlassCard({ className = '', children }) {
  return (
    <div className={`w-full text-ink-primary ${className}`}>
      {children}
    </div>
  )
}
